import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Navbar } from './navbar/navbar';

@Component({
  imports: [CommonModule, RouterOutlet, Navbar],
    selector: 'app-secure',
  styleUrls: ['./secure.scss'],
  templateUrl: './secure.html',
})
export class Secure {}
